import * as msal from "@azure/msal-browser";
import {IObjectWithKey} from "@fluentui/react";
import {Document} from "../../types/types";
import {
	SET_GROUP_ID,
	LOGOUT,
	SET_POPUP,
	SET_LOADING,
	SET_LOGIN_ERROR,
	SET_TOKEN,
	SET_USER,
	SET_AUTHENTICATED,
	SET_PUBLIC_CLIENT,
	SET_DOCUMENT_DATA,
	SET_SELECTED_DOCUMENTS,
	SET_PARENT_ID,
	SET_IS_ROOT_DIR, SET_RESOURCE_DENIED,
} from "../actionTypes";
import fileDownload from "js-file-download";
import {scopes} from "../../auth-config";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

export const login = (
	scopes: msal.AuthorizationUrlRequest,
	method: string
) => {
	return (dispatch: any, getState: any) => {
		const signInType = isIE || isEdge ? "loginRedirect" : method;
		if (signInType === "loginPopup") {
			dispatch(setPopup(true));
			(async () => {
				try {
					await getState().data.msalClient.loginPopup(scopes);
					if (
						getState().data.msalClient.getAccountByUsername(
							getState().data.msalClient.getAllAccounts()[0].username
						)
					) {
						dispatch(setUser(getState().data.msalClient.getAllAccounts()[0]));
						dispatch(setAuthenticated(true));
						// Get document data
						dispatch(getGroupDriveFiles(scopes));
					}
				} catch (error) {
					console.error(error);
					dispatch(setLoginError(error));
				} finally {
					dispatch(setPopup(false));
				}
			})();
		} else if (signInType === "loginRedirect") {
			dispatch(setLoading(true));
			getState().data.msalClient.loginRedirect(scopes);
		}
	};
};

const getTokenPopup = (loginRequest: msal.AuthorizationUrlRequest) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			try {
				const {
					accessToken,
				} = await getState().data.msalClient.acquireTokenSilent({
					account: getState().data.user,
					scopes: loginRequest.scopes,
				});
				dispatch(setToken(accessToken));
			} catch (error) {
				try {
					dispatch(setPopup(true));

					const {
						accessToken,
					} = await getState().data.msalClient.acquireTokenSilent({
						account: getState().data.user,
						scopes: loginRequest.scopes,
					});
					dispatch(setToken(accessToken));
				} catch (err) {
					console.error(err);
					dispatch(setLoginError(err));
				} finally {
					dispatch(setPopup(false));
				}
			}
		})();
	};
};

const getTokenRedirect = (loginRequest: msal.AuthorizationUrlRequest) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			try {
				const {
					accessToken,
				} = await getState().data.msalClient.acquireTokenSilent({
					account: getState().data.user,
					scopes: loginRequest.scopes,
				});
				dispatch(setToken(accessToken));
			} catch (error) {
				try {
					dispatch(setLoading(true));

					getState().data.msalClient.acquireTokenRedirect(loginRequest);
				} catch (err) {
					console.error(err);
					dispatch(setLoginError(err));
				}
			}
		})();
	};
};

export const getToken = (
	loginRequest: msal.AuthorizationUrlRequest,
	method: string
) => {
	const signInType = isIE || isEdge ? "loginRedirect" : method;
	if (signInType === "loginRedirect") {
		return getTokenRedirect(loginRequest);
	} else {
		return getTokenPopup(loginRequest);
	}
};

export const getGroupDriveFiles = (
	loginRequest: msal.AuthorizationUrlRequest
) => {
	return (dispatch: any, getState: any) => {
		if (getState().data.user) {
			(async () => {
				const {
					accessToken,
				} = await getState().data.msalClient.acquireTokenSilent({
					account: getState().data.user,
					scopes: loginRequest.scopes,
				});
				dispatch(setToken(accessToken));

				await fetch(
					`https://graph.microsoft.com/v1.0/groups/${
						getState().data.groupId
					}/drive/root/children`,
					{
						headers: {
							authorization: `Bearer ${getState().data.token}`,
						},
					}
				).then((res) => {
					if (res.status !== 200) {
						dispatch(setResourceDenied(true))
					} else {
						dispatch(setResourceDenied(false))
						return res.json();
					}
				}).then((json) => {
					const value = json.value;

					if (value.length > 0) {
						dispatch(setIsRootDir(true));
						dispatch(setDocumentData(value));
						// Set Parent Id Reference
						dispatch(setParentId(value[0].parentReference.id));
					} else {
						dispatch(setDocumentData([]));
					}
				}).catch(() => {
					setResourceDenied(true);
				});
			})();
		}
	};
};

// export const tryLogin = (loginRequest: msal.AuthorizationUrlRequest) => {
//   return (dispatch: any, getState: any) => {
//     (async () => {
//       try {
//         console.log(getState().data.user);
//         const {
//           accessToken,
//         } = await getState().data.msalClient.acquireTokenSilent({
//           account: getState().data.user,
//           scopes: loginRequest.scopes,
//         });
//         console.log(getState().data.user, accessToken);
//         console.log("ATTEMPTING TO SET TOKEN");
//         dispatch(setToken(accessToken));
//       } catch (e: any) {}
//     })();
//   };
// };

export const downloadFileInDrive = (url: string, fileName: string) => {
	return () => {
		(async () => {
			await fetch(url, {
				method: "GET",
			})
				.then((res: Response) => res.blob())
				.then((blob: Blob) => fileDownload(blob, fileName));
		})();
	};
};

/* Document Creation Section */

export const createFolder = (name: string) => {
	return (dispatch: any, getState: any) => {
		(async () => {

			const driveItem = {
				name: name,
				folder: {}
			}

			await fetch(`https://graph.microsoft.com/v1.0/groups/${
				getState().data.groupId
			}/drive/items/${getState().data.parentId}/children`, {
				method: "POST",
				headers: {
					authorization: `Bearer ${getState().data.token}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(driveItem)
			}).then((res: Response) => {
				if (res.status === 200 || res.status === 201) {
					dispatch(refreshList());
				}
			})
		})();
	}
}

export const createFile = (name: string, documentType: string) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			const file = await fetch(`https://sp.resop.no/templates/${documentType}`, {
				mode: "cors"
			})
				.then((res: any) => {
					return res.blob();
				})
				.catch((err: any) => console.error(err));

			await fetch(
				`https://graph.microsoft.com/v1.0/groups/${
					getState().data.groupId
				}/drive/items/${getState().data.parentId}:/${name + "." + documentType.split(".")[1]}:/content`,
				{
					method: "PUT",
					headers: {
						authorization: `Bearer ${getState().data.token}`,
						"Content-Type": "text/plain",
					},
					body: file,
				}
			)
				.then((res: Response) => {
					res.json();
					dispatch(refreshList());
				})
				.catch((err: any) => console.error(err));
		})();
	}
}

/* End of Document Creation Section */

export const deleteDocument = (itemId: string) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			await fetch(
				`https://graph.microsoft.com/v1.0/groups/${
					getState().data.groupId
				}/drive/items/${itemId}`,
				{
					method: "DELETE",
					headers: {
						authorization: `Bearer ${getState().data.token}`,
					},
				}
			)
				.then((res: Response) => {
					res.json();
					dispatch(refreshList());
				})
				.catch((err: any) => console.error(err));
		})();
	};
};

export const uploadSmallFile = (file: File) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			await fetch(
				`https://graph.microsoft.com/v1.0/groups/${
					getState().data.groupId
				}/drive/items/${getState().data.parentId}:/${file.name}:/content`,
				{
					method: "PUT",
					headers: {
						authorization: `Bearer ${getState().data.token}`,
						"Content-Type": "text/plain",
					},
					body: file,
				}
			)
				.then((res: Response) => {
					res.json();
					dispatch(refreshList());
				})
				.catch((err: any) => console.error(err));
		})();
	};
};

export const uploadLargeFile = (file: File) => {
	return (dispatch: any, getState: any) => {
		(async () => {
			let uploadUrl = "";
			// Get the upload url for the file upload session
			await fetch(
				`https://graph.microsoft.com/v1.0/groups/${
					getState().data.groupId
				}/drive/items/${getState().data.parentId}:/${
					file.name
				}:/createUploadSession`,
				{
					method: "POST",
					headers: {
						authorization: `Bearer ${getState().data.token}`,
					},
				}
			)
				.then((res: any) => res.json())
				.then((json: any) => (uploadUrl = json.uploadUrl))
				.catch((err: any) => console.error(err));

			/* NEW LOGIC SECTION */
			// variables for byte stream position

			let position = 0;
			let chunkLength = 320 * 1024;

			let continueRead = true;
			while (continueRead) {
				let chunk: any;
				try {
					continueRead = true;
					// Try to read in the chunk
					try {
						let stopByte = position + chunkLength;
						console.debug(
							"Sending Asynchronous request to read in chunk bytes from position " +
							position +
							" to end " +
							stopByte
						);

						chunk = await readFragmentAsync(file, position, stopByte);
						console.debug(
							"UploadChunks: Chunk read in of " + chunk.byteLength + " bytes."
						);
						if (chunk.byteLength > 0) {
							continueRead = true;
						} else {
							break;
						}
						console.debug("Chunk bytes received = " + chunk.byteLength);
					} catch (e) {
						console.debug("Bytes Received from readFragmentAsync:: " + e);
						break;
					}
					// Try to upload the chunk
					// Try to upload the chunk.
					try {
						console.debug("Request sent for uploadFragmentAsync");
						await uploadChunk(
							chunk,
							uploadUrl,
							position,
							file.size,
							getState().data.token
						)
							.then((res: any) => {
								if (
									res.status !== 202 &&
									res.status !== 201 &&
									res.status !== 200
								)
									throw "Put operation did not return expected response";

								if (res.status === 201 || res.status === 200) {
									console.debug(
										"Reached last chunk of file.  Status code is: " + res.status
									);
									continueRead = false;
								} else {
									console.debug("Continuing - Status Code is: " + res.status);
									return res.json();
								}
							})
							.then((json: any) => {
								if (json) {
									position = Number(json.nextExpectedRanges[0].split("-")[0]);
								}

								console.debug("Successful response received from uploadChunk.");
								console.debug("Position is now " + position);
							});
					} catch (e) {
						console.error("Error occured when calling uploadChunk::" + e);
					}
				} catch (e) {
					continueRead = false;
				}
			}
			dispatch(refreshList());
		})();
	};
};

const uploadChunk = (
	chunk: any,
	uploadUrl: string,
	position: any,
	totalLength: any,
	token: any
) => {
	let max = position + chunk.byteLength - 1;

	console.debug("Chunk size is: " + chunk.byteLength + " bytes.");

	let crHeader = "bytes " + position + "-" + max + "/" + totalLength;
	//Execute PUT request to upload the content range.

	return fetch(uploadUrl, {
		method: "PUT",
		headers: {
			authorization: `Bearer ${token}`,
			"Content-Type": "application/octet-stream",
			"Content-Range": crHeader,
		},
		body: chunk,
	});
};

const readFragmentAsync = (file: File, startByte: any, stopByte: any) => {
	let frag: string | ArrayBuffer = "";
	const reader = new FileReader();
	console.debug("startByte:", startByte, "stopByte:", stopByte);
	let blob = file.slice(startByte, stopByte);
	reader.readAsArrayBuffer(blob);
	return new Promise((resolve) => {
		reader.onloadend = () => {
			if (reader.readyState === reader.DONE) {
				frag = reader.result;
				resolve(frag);
			}
		};
	});
};

export const getFilesInFolder = (
	loginRequest: msal.AuthorizationUrlRequest,
	id: string
) => {
	return (dispatch: any, getState: any) => {
		if (getState().data.user) {
			(async () => {
				const {
					accessToken,
				} = await getState().data.msalClient.acquireTokenSilent({
					account: getState().data.user,
					scopes: loginRequest.scopes,
				});
				dispatch(setToken(accessToken));

				await fetch(
					`https://graph.microsoft.com/v1.0/groups/${
						getState().data.groupId
					}/drive/items/${id}/children`,
					{
						headers: {
							authorization: `Bearer ${accessToken}`,
						},
					}
				).then((res) => {
					if (res.status !== 200) {
						dispatch(setResourceDenied(true))
					} else {
						dispatch(setResourceDenied(false))
						return res.json();
					}
				}).then((json) => {
					const value = json.value;

					if (value.length > 0) {
						dispatch(setDocumentData(value));
					} else {
						dispatch(setDocumentData([]));
					}
					dispatch(setIsRootDir(false));
				}).catch(() => {
					dispatch(setResourceDenied(true))
				});
			})();
		}
	};
};

export const refreshList = () => {
	return (dispatch: any, getState: any) => {
		if (getState().data.isRootDir) {
			dispatch(getGroupDriveFiles(scopes));
		} else {
			dispatch(getFilesInFolder(scopes, getState().data.parentId));
		}
	};
};

export const logout = () => {
	return (dispatch: any, getState: any) => {
		getState().data.msalClient.logout();
		dispatch({
			type: LOGOUT,
		});
	};
};

export const setPopup = (popup: boolean) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_POPUP,
			popupOpen: popup,
		});
	};
};

export const setLoading = (loading: boolean) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_LOADING,
			loading: loading,
		});
	};
};

export const setLoginError = (error: string) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_LOGIN_ERROR,
			loginError: error,
		});
	};
};

export const setToken = (token: string) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_TOKEN,
			token: token,
		});
	};
};

export const setAuthenticated = (isAuthenticated: boolean) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_AUTHENTICATED,
			isAuthenticated: isAuthenticated,
		});
	};
};

export const setUser = (user: msal.AccountInfo) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_USER,
			user: user,
		});
	};
};

export const setPublicClient = (msalClient: msal.PublicClientApplication) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_PUBLIC_CLIENT,
			msalClient: msalClient,
		});
	};
};

export const setDocumentData = (documents: Document[]) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_DOCUMENT_DATA,
			documents: documents,
		});
	};
};

export const setSelectedDocuments = (selectedDocuments: IObjectWithKey[]) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_SELECTED_DOCUMENTS,
			selectedDocuments: selectedDocuments,
		});
	};
};

export const setParentId = (parentId: string) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_PARENT_ID,
			parentId: parentId,
		});
	};
};

export const setIsRootDir = (isRootDir: boolean) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_IS_ROOT_DIR,
			isRootDir: isRootDir,
		});
	};
};

export const setGroupId = (groupId: string) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_GROUP_ID,
			groupId: groupId,
		});
	};
};

export const setResourceDenied = (resourceDenied: boolean) => {
	return (dispatch: any) => {
		dispatch({
			type: SET_RESOURCE_DENIED,
			resourceDenied: resourceDenied,
		});
	};
};
